import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungHannover() {
  return (
    <CityPageTemplate
      city="Hannover"
      slug="hannover"
      intro="Hannover als starker Wirtschaftsstandort bietet beste Voraussetzungen für smarten Vermögensaufbau."
      description="Unabhängige Finanzberatung für Hannover – 100% digital, kostenlose Erstberatung. Altersvorsorge, ETF, Steueroptimierung & staatliche Förderungen."
    />
  );
}
